export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#BAF600" },
        { className: "secondary-bg-colour", colour: "#9E00B3" },
        { className: "tertiary-bg-colour", colour: "#232323" },
        { className: "misc-bg-colour", colour: "#000000" },
    ],
    text: [
        { className: "primary-text", colour: "#FFFFFF" },
        { className: "secondary-text", colour: "#000" },
        { className: "tertiary-text", colour: "#FFFFFF" },
        { className: "misc-text", colour: "#E374FF" },
        { className: "super-misc-text", colour: "#9E00B3" },
    ],
    borders: [
        { className: "primary-border-colour", colour: "#EF151C" },
        { className: "secondary-border-colour", colour: "#FFCB05" },
    ],
};
